var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{attrs:{"d":"M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }